import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { BaseModelHelper } from "../helpers/base_model_helper.js";
import { BaseMongoHelper } from "../helpers/base_mongo_helper.js";
import { isCompoundItem } from "./menu_item_utils.js";
import { DiscountType, EnvironmentHelper, OrderChannelHelper, OrderPaymentDestination, OrderRefundState, OrdersApiVersion, RewardType } from "@biteinc/enums";
import { systemIsPos } from "@biteinc/common";
//#region src/utils/order_utils.ts
var order_utils_exports = /* @__PURE__ */ __exportAll({
	addRefund: () => addRefund,
	addUnappliedReward: () => addUnappliedReward,
	attachPosFieldsToOrderedItems: () => attachPosFieldsToOrderedItems,
	correctForCombos: () => correctForCombos,
	correctPrices: () => correctPrices,
	createRefundReference: () => createRefundReference,
	discountTotalFromDiscounts: () => discountTotalFromDiscounts,
	extendI9nData: () => extendI9nData,
	extendVendorData: () => extendVendorData,
	formatI9nValidationData: () => formatI9nValidationData,
	formatNonIntegratedValidationData: () => formatNonIntegratedValidationData,
	generateRangedOrderNumber: () => generateRangedOrderNumber,
	generateShortSeqNumber: () => generateShortSeqNumber,
	getDiscountNames: () => getDiscountNames,
	getDiscountNamesArray: () => getDiscountNamesArray,
	getI9nDataForId: () => getI9nDataForId,
	getIndexOfI9nDataForId: () => getIndexOfI9nDataForId,
	getIntegrationIds: () => getIntegrationIds,
	getOrderedItemsWithIntegrationId: () => getOrderedItemsWithIntegrationId,
	getOrderedItemsWithPosFields: () => getOrderedItemsWithPosFields,
	getOrderedItemsWithVendorId: () => getOrderedItemsWithVendorId,
	getOriginEnvironment: () => getOriginEnvironment,
	getPosDataForVendor: () => getPosDataForVendor,
	getVendorIds: () => getVendorIds,
	hasBeenSentToKitchen: () => hasBeenSentToKitchen,
	isBiteFutureOrder: () => isBiteFutureOrder,
	isClosed: () => isClosed,
	isFullyDiscounted: () => isFullyDiscounted,
	isI9nFutureOrder: () => isI9nFutureOrder,
	isKiosk: () => isKiosk,
	isLoyaltyPaymentReward: () => isLoyaltyPaymentReward,
	isOrdersApiV2: () => isOrdersApiV2,
	isOrdersApiV2OrV3: () => isOrdersApiV2OrV3,
	isOrdersApiV3: () => isOrdersApiV3,
	isPaidAtCashier: () => isPaidAtCashier,
	recalculateTotal: () => recalculateTotal,
	setCompCardAuthData: () => setCompCardAuthData,
	setLoyaltyAuthData: () => setLoyaltyAuthData,
	setTipForIntegrationWithId: () => setTipForIntegrationWithId
});
function setI9nComboFields(item, correctionById) {
	const comboCorrection = correctionById[item.orderedItemId.toString()];
	if (!comboCorrection) return item;
	item.i9nComboId = comboCorrection.comboI9nId;
	item.i9nComboPrice = comboCorrection.comboPrice;
	item.i9nComboName = comboCorrection.comboName;
	return item;
}
function correctForCombos(data) {
	const { itemComboCorrectionById, orderedItems, clientOrderedItems } = data;
	if (!itemComboCorrectionById) return;
	orderedItems.forEach((orderedItem) => {
		setI9nComboFields(orderedItem, itemComboCorrectionById);
	});
	clientOrderedItems.forEach((orderedItem) => {
		setI9nComboFields(orderedItem, itemComboCorrectionById);
	});
}
function correctOrderedItemPrices(parentItem, itemCorrectionById) {
	const correctedPrice = itemCorrectionById[parentItem.orderedItemId.toString()];
	(parentItem.priceOption.addonSets ?? []).forEach((modGroup) => {
		modGroup.items = (modGroup.items ?? []).map((item) => {
			return correctOrderedItemPrices(item, itemCorrectionById);
		});
	});
	if (correctedPrice) {
		if (parentItem.priceOption.originalPrice === void 0) parentItem.priceOption.originalPrice = parentItem.priceOption.price;
		if (parentItem.priceOption.originalUnitPrice === void 0) parentItem.priceOption.originalUnitPrice = parentItem.priceOption.unitPrice;
		parentItem.priceOption.price = parentItem.priceOption.quantity * correctedPrice.unitPrice * (parentItem.priceOption.weight || 1);
		parentItem.priceOption.unitPrice = correctedPrice.unitPrice;
	}
	return parentItem;
}
function correctPrices(data) {
	const { itemPriceCorrectionById, orderedItems, clientOrderedItems } = data;
	if (!itemPriceCorrectionById) return;
	orderedItems.forEach((orderedItem) => {
		correctOrderedItemPrices(orderedItem, itemPriceCorrectionById);
	});
	clientOrderedItems.forEach((orderedItem) => {
		correctOrderedItemPrices(orderedItem, itemPriceCorrectionById);
	});
}
function discountTotalFromDiscounts(data, discounts) {
	return (discounts ?? []).reduce((totalDiscountAmount, discount) => {
		if (discount.type === DiscountType.Percent) if (discount.itemId) {
			if (data.orderedItems.find((orderedItem) => {
				return orderedItem._id.equals(discount.itemId);
			})) return totalDiscountAmount + discount.amount;
		} else return totalDiscountAmount + discount.amount;
		return totalDiscountAmount + discount.amount;
	}, 0);
}
function getIndexOfPosDataForVendor(data, vendorId) {
	return data.dataForVendors.findIndex((i9nData) => {
		return i9nData.vendorId?.equals(vendorId);
	});
}
function extendVendorData(data, vendorId, orderData) {
	const posData = getPosDataForVendor(data, vendorId) || { vendorId };
	const idx = getIndexOfPosDataForVendor(data, vendorId);
	if (idx < 0) data.dataForVendors.push(Object.assign(posData, orderData));
	else data.dataForVendors[idx] = Object.assign(posData, orderData);
}
function formatNonIntegratedValidationData(vendorId, validationData, optData) {
	return Object.assign({
		vendorId,
		validatedAt: Date.now(),
		...validationData && Object.keys(validationData).length && { validationData }
	}, optData || {});
}
function formatI9nValidationData(i9n, validationData, optData, skipValidateReason) {
	return Object.assign({
		_id: i9n.id,
		integrationId: i9n.id,
		system: i9n.data.system,
		...formatNonIntegratedValidationData(i9n.data.vendorId, validationData, optData),
		...skipValidateReason && { validationWasSkipped: skipValidateReason }
	}, optData || {});
}
function generateShortSeqNumber(sequenceNumber) {
	return `${1e3 + sequenceNumber % 9e3}`;
}
function generateRangedOrderNumber(sequenceNumber, lowerBound, upperBound) {
	return `${lowerBound + sequenceNumber % (upperBound - lowerBound + 1)}`;
}
function getDiscountNamesArray(data, integrationIds) {
	const discountNames = [];
	getIntegrationIds(data).forEach((integrationId) => {
		if (integrationIds && !BaseMongoHelper.contains(integrationIds, integrationId)) return;
		((getI9nDataForId(data, integrationId) || { integrationId }).discounts ?? []).forEach((discount) => {
			discountNames.push(discount.name);
		});
	});
	return discountNames;
}
function getDiscountNames(data, integrationIds) {
	return getDiscountNamesArray(data, integrationIds).join(", ");
}
function getIntegrationIds(data) {
	const integrationIdById = {};
	data.orderedItems.forEach(({ integrationId }) => {
		if (integrationId) integrationIdById[integrationId.toString()] = integrationId;
	});
	return Object.values(integrationIdById);
}
function getOriginEnvironment() {
	const originEnvironment = EnvironmentHelper.current();
	if (!originEnvironment) throw new Error("Invalid originEnvironment");
	return originEnvironment;
}
function getPosDataForVendor(data, vendorId) {
	return data.dataForVendors.find((i9nData) => {
		const vId = i9nData.vendorId;
		if ("system" in i9nData && !systemIsPos(i9nData.system)) return false;
		return vId?.equals(vendorId);
	});
}
function getOrderedItemsWithIntegrationId(data, integrationId) {
	return data.orderedItems.filter((orderedItem) => {
		return orderedItem.integrationId?.equals(integrationId);
	});
}
function getOrderedItemsWithVendorId(data, vendorId) {
	return data.orderedItems.filter((orderedItem) => {
		return orderedItem.vendor?._id.equals(vendorId);
	});
}
function getVendorIds(data) {
	const vendorById = {};
	data.orderedItems.forEach(({ vendor }) => {
		vendorById[vendor._id.toString()] = vendor._id;
	});
	return Object.values(vendorById);
}
async function attachPosFieldsToOrderedItems(MenuItem, orderedItems) {
	const menuItemProps = [
		"_id",
		"posFields",
		"constituentItems"
	];
	const constituentItemProps = [
		"_id",
		"posFields",
		"priceOptions"
	];
	const menuItemIds = orderedItems.map((orderedItem) => {
		return orderedItem._id;
	});
	const menuItems = await MenuItem.findProjectedData({ _id: { $in: menuItemIds } }, menuItemProps);
	const menuItemById = BaseModelHelper.idMapData(menuItems);
	/**
	* Get our compound item's constituent items
	* @todo
	* - when we refactor for menus api v2 we will aim to remove compound item specific logic
	*/
	const constituentItemIds = menuItems.flatMap((menuItem) => {
		return (menuItem.constituentItems || []).map((constituentItem) => {
			return constituentItem._id;
		});
	});
	const constituentItems = await MenuItem.findProjectedData({ _id: { $in: constituentItemIds } }, constituentItemProps);
	const constituentItemByPriceOptionId = /* @__PURE__ */ new Map();
	constituentItems.forEach((constituentItem) => {
		constituentItemByPriceOptionId.set(constituentItem.priceOptions[0]._id.toString(), constituentItem);
	});
	return orderedItems.map((orderedItem) => {
		let menuItem = menuItemById[orderedItem._id.toString()];
		if (isCompoundItem(menuItem)) menuItem = constituentItemByPriceOptionId.get(orderedItem.priceOption._id.toString());
		const menuItemPosFields = menuItem?.posFields;
		return {
			...orderedItem,
			...menuItemPosFields && { posFields: menuItemPosFields }
		};
	});
}
async function getOrderedItemsWithPosFields(MenuItem, data, integrationId) {
	return attachPosFieldsToOrderedItems(MenuItem, getOrderedItemsWithIntegrationId(data, integrationId));
}
function isKiosk(data) {
	return OrderChannelHelper.isKiosk(data.channel);
}
function isPaidAtCashier(data) {
	return data.paymentDestination === OrderPaymentDestination.Cashier;
}
function getCalculatedTotal(data) {
	return data.subTotal - (data.discountTotal || 0) + data.taxTotal + (data.tipTotal || 0) + (data.serviceChargeTotal || 0) + (data.donationTotal || 0);
}
function isFullyDiscounted(data) {
	return data.subTotal > 0 && getCalculatedTotal(data) === 0;
}
function hasBeenSentToKitchen(data) {
	return !!data.wasSentToPos;
}
function isOrdersApiV2(data) {
	return data.ordersApiVersion === OrdersApiVersion.V2;
}
function isOrdersApiV2OrV3(data) {
	return data.ordersApiVersion === OrdersApiVersion.V2 || data.ordersApiVersion === OrdersApiVersion.V3;
}
function isOrdersApiV3(data) {
	return data.ordersApiVersion === OrdersApiVersion.V3;
}
function isClosed(data) {
	return isOrdersApiV2OrV3(data) && !!data.isClosed;
}
function recalculateTotal(order) {
	const integrationIds = order.getIntegrationIds();
	if (integrationIds.length) {
		let subTotal = 0;
		let taxTotal = 0;
		let discountTotal = 0;
		let tipTotal = 0;
		let serviceChargeTotal = 0;
		let donationTotal = 0;
		let total = 0;
		integrationIds.forEach((integrationId) => {
			const i9nData = order.getI9nDataForId(integrationId) || { integrationId };
			subTotal += i9nData.subTotal || 0;
			taxTotal += i9nData.taxTotal || 0;
			tipTotal += i9nData.tipTotal || 0;
			serviceChargeTotal += i9nData.serviceChargeTotal || 0;
			donationTotal += i9nData.donationTotal || 0;
			i9nData.discountTotal = Math.min(discountTotalFromDiscounts(order.data, i9nData.discounts), subTotal);
			discountTotal += i9nData.discountTotal || 0;
			total += i9nData.total || 0;
		});
		order.set("subTotal", subTotal);
		order.set("taxTotal", taxTotal);
		order.set("total", total);
		if (discountTotal >= 0 && getDiscountNames(order.data, integrationIds)) order.set("discountTotal", discountTotal);
		else if (order.has("discountTotal")) order.set("discountTotal", 0);
		if (tipTotal > 0) order.set("tipTotal", tipTotal);
		if (tipTotal === 0 && order.has("tipTotal") && order.data.tipTotal > 0) order.set("total", order.data.total + order.data.tipTotal);
		if (serviceChargeTotal > 0 || order.has("serviceChargeTotal")) order.set("serviceChargeTotal", serviceChargeTotal);
		if (donationTotal > 0 || order.has("donationTotal")) order.set("donationTotal", donationTotal);
	} else {
		order.set("discountTotal", 0);
		order.set("total", order.data.subTotal + (order.data.taxTotal || 0) - order.data.discountTotal + (order.data.tipTotal || 0) + (order.data.serviceChargeTotal || 0) + (order.data.donationTotal || 0));
	}
}
function setTipForIntegrationWithId(order, tipTotal, integrationId) {
	const i9nData = order.getI9nDataForId(integrationId) || { integrationId };
	if (tipTotal > 0) {
		if (i9nData.tipTotal) i9nData.total -= i9nData.tipTotal;
		i9nData.tipTotal = tipTotal;
		i9nData.total += tipTotal;
		order.data.integrationById[integrationId.toString()] = i9nData;
	} else {
		i9nData.total -= i9nData.tipTotal;
		delete i9nData.tipTotal;
		order.data.integrationById[integrationId.toString()] = i9nData;
	}
	order.recalculateTotal();
}
function setLoyaltyAuthData(order, loyaltyAuthData) {
	order.loyaltyAuthData = loyaltyAuthData;
	order.data.hasLoyaltyProgram = !!loyaltyAuthData;
}
function setCompCardAuthData(order, compCardAuthData) {
	order.compCardAuthData = compCardAuthData;
}
function getI9nDataForId(data, i9nId) {
	return data.dataForVendors.find((i9nData) => {
		if (!("integrationId" in i9nData)) return;
		return i9nData.integrationId?.equals(i9nId);
	});
}
function getIndexOfI9nDataForId(data, i9nId) {
	return data.dataForVendors.findIndex((i9nData) => {
		if (!("integrationId" in i9nData)) return;
		return i9nData.integrationId?.equals(i9nId);
	});
}
/**
* @todo
* Remove setting integrationById when all clients are updated
*/
function extendI9nData(data, i9nData, moreI9nData) {
	let existingI9nData = getI9nDataForId(data, i9nData._id);
	if (!existingI9nData) existingI9nData = {
		integrationId: i9nData._id,
		_id: i9nData._id,
		system: i9nData.system,
		vendorId: i9nData.vendorId
	};
	const idx = getIndexOfI9nDataForId(data, i9nData._id);
	if (idx < 0) data.dataForVendors.push(Object.assign(existingI9nData, moreI9nData));
	else data.dataForVendors[idx] = Object.assign(existingI9nData, moreI9nData);
	data.integrationById[i9nData._id.toString()] = Object.assign(existingI9nData, moreI9nData);
}
function isBiteFutureOrder(data) {
	return !!data.isBiteFutureOrder;
}
function isI9nFutureOrder(data) {
	return !!data.isI9nFutureOrder;
}
function addUnappliedReward(data, reward) {
	data.unappliedRewards = [...[...data.unappliedRewards ?? []], reward];
}
function isLoyaltyPaymentReward(reward) {
	return !!reward.transactionId && [
		RewardType.Payment,
		RewardType.WalletAndPayment,
		RewardType.WalletAndPaymentTaxExempt
	].includes(reward.type);
}
function getUnrefundedTotals(orderData) {
	const { subTotal, taxTotal, tipTotal, serviceChargeTotal, donationTotal, discountTotal } = orderData;
	const initialValue = {
		subTotal,
		taxTotal,
		tipTotal,
		serviceChargeTotal,
		discountTotal,
		donationTotal
	};
	return (orderData.refunds ?? []).reduce((totals, refund) => {
		totals.subTotal -= refund.subTotal || 0;
		totals.taxTotal -= refund.taxTotal || 0;
		totals.discountTotal -= refund.discountTotal || 0;
		totals.tipTotal = (totals.tipTotal || 0) - (refund.tipTotal || 0);
		totals.serviceChargeTotal = (totals.serviceChargeTotal || 0) - (refund.serviceChargeTotal || 0);
		totals.donationTotal = (totals.donationTotal || 0) - (refund.donationTotal || 0);
		return totals;
	}, initialValue);
}
function createRefundReference({ newObjectId }, orderData, transactionId, refundAmount, refundTransaction, accessUsername, accessUserId) {
	const refundSequenceKeys = [
		"discountTotal",
		"subTotal",
		"taxTotal",
		"tipTotal",
		"serviceChargeTotal",
		"donationTotal"
	];
	const unrefundedAmounts = getUnrefundedTotals(orderData);
	unrefundedAmounts.discountTotal = -unrefundedAmounts.discountTotal;
	let remainingRefundAmount = refundAmount;
	const partialRefundAmounts = {};
	refundSequenceKeys.forEach((key) => {
		const unrefundedAmount = unrefundedAmounts[key] || 0;
		const refundAmountForKey = Math.min(remainingRefundAmount, unrefundedAmount);
		partialRefundAmounts[key] = refundAmountForKey;
		remainingRefundAmount -= refundAmountForKey;
	});
	const { subTotal, taxTotal, discountTotal, tipTotal, serviceChargeTotal, donationTotal } = partialRefundAmounts;
	return {
		_id: newObjectId(),
		state: OrderRefundState.Refunded,
		subTotal,
		taxTotal,
		...-discountTotal > 0 && { discountTotal: -discountTotal },
		...tipTotal > 0 && { tipTotal },
		...serviceChargeTotal > 0 && { serviceChargeTotal },
		...donationTotal > 0 && { donationTotal },
		total: refundAmount,
		transactionId,
		...accessUserId && { accessUserId },
		accessUsername,
		createdAt: refundTransaction.data.createdAt,
		refundTransactionId: refundTransaction.id
	};
}
async function addRefund(utils, order, transactionId, refundAmount, refundTransaction, accessUsername, accessUserId) {
	const refund = createRefundReference(utils, order.data, transactionId, refundAmount, refundTransaction, accessUsername, accessUserId);
	return order.saveWithDict({ $push: { refunds: refund } });
}
//#endregion
export { addRefund, addUnappliedReward, attachPosFieldsToOrderedItems, correctForCombos, correctPrices, createRefundReference, discountTotalFromDiscounts, extendI9nData, extendVendorData, formatI9nValidationData, formatNonIntegratedValidationData, generateRangedOrderNumber, generateShortSeqNumber, getDiscountNames, getDiscountNamesArray, getI9nDataForId, getIndexOfI9nDataForId, getIntegrationIds, getOrderedItemsWithIntegrationId, getOrderedItemsWithPosFields, getOrderedItemsWithVendorId, getOriginEnvironment, getPosDataForVendor, getVendorIds, hasBeenSentToKitchen, isBiteFutureOrder, isClosed, isFullyDiscounted, isI9nFutureOrder, isKiosk, isLoyaltyPaymentReward, isOrdersApiV2, isOrdersApiV2OrV3, isOrdersApiV3, isPaidAtCashier, order_utils_exports, recalculateTotal, setCompCardAuthData, setLoyaltyAuthData, setTipForIntegrationWithId };

//# sourceMappingURL=order_utils.js.map